import { createContext, useContext, useState, useCallback } from "react";
import { translations } from "../lib/translations";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("sm_lang") || "fr");
  const toggle = useCallback(() => {
    setLang((prev) => {
      const next = prev === "fr" ? "en" : "fr";
      localStorage.setItem("sm_lang", next);
      return next;
    });
  }, []);
  const t = useCallback((key) => translations[lang][key] ?? key, [lang]);
  return (
    <LanguageContext.Provider value={{ lang, toggle, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
